export class UserInfo {
    client_ID: string;
    maxbet_ID: string;
    firstName: string;
    lastName: string;
    username: string;
    email: string;
    phone: string;
    rankProgress: number | undefined;
    pointsCount: number | undefined;
    barCode: string | undefined;
    expiringMbcNotificationType: string | undefined;
    expiringMbcPoints: number | undefined;

    constructor(client_ID: string, maxbet_ID: string,
        firstName: string, lastName: string, username: string,
        email: string, phone: string,
        pointsCount: number | undefined,
        rankProgress: number | undefined,
        barCode: string | undefined,
        expiringMbcNotificationType: string | undefined,
        expiringMbcPoints: number | undefined) {

        this.client_ID = client_ID;
        this.maxbet_ID = maxbet_ID;
        this.firstName = firstName;
        this.lastName = lastName;
        this.rankProgress = rankProgress;
        this.pointsCount = pointsCount;
        this.email = email;
        this.phone = phone;
        this.username = username;
        this.barCode = barCode;
        this.expiringMbcNotificationType = expiringMbcNotificationType;
        this.expiringMbcPoints = expiringMbcPoints;
    }
}

export class SaveUserInfo {
    client_ID: string | undefined;
    phone: string;

    constructor(client_ID: string | undefined, phone: string) {
        this.client_ID = client_ID;
        this.phone = phone;
    }
}